<div class="page_title">
  <div class="container-fluid">
    <div class="row">
      <div class="col-auto" *ngIf="this.claimId">
        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
          [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()">
        </k-button>
      </div>
      <div class="col">
        <h3>Immunohistochemistry Profiling</h3>
        <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="pages_space">
    <div class="row">
      <div class="col-12 col-sm-auto">
        <div class="card_claimInfo_wrap">
          <div class="row">
            <div class="col-12" style="margin-top: 5px;">
              <k-card [card]="claimInfo"></k-card>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="margin-top: 5px;">
              <k-card [card]="claimInfo2"></k-card>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm">
        <div class="asbestosis-med-records-container">
          <div class="antigen-marker">
            <div class="multi-select-dropdown" #multiSelectDropDown>
              <span class="antigen-marker-header"> Markers </span>
              <div class="dropdown-input">
                <!-- <div class="selected-options" > -->
                <!-- <span *ngFor="let option of selectedOptions" class="selected-option" >
            {{ option.marker }}
            <span class="remove-option" (click)="removeSelection(option)"
              >&#10005;</span
            >
          </span> -->
                <!-- </div> -->
                <input type="text" placeholder="Pick Markers" [(ngModel)]="searchText" (click)="toggleDropdown()"
                  (keyup)="filterOptions()" [style.width]="inputWidth" />
                <div class="search-icon-svg" (click)="toggleDropdown()">
                  <i><img src="../../../../assets/images/search-icon.png" /></i>

                </div>
              </div>
              <div class="dropdown-list" *ngIf="dropdownOpen">
                <ng-container *ngFor="let option of filteredOptions">
                  <label>
                    <div class="dropdown-item">
                      <input type="checkbox" [checked]="isSelected(option)" (click)="toggleSelection(option)" />
                      <span class="item-text"> {{ option.marker }}</span>
                    </div>
                  </label>
                </ng-container>
                <span class="no-markers" *ngIf="filteredOptions.length === 0">No markers found</span>
              </div>
            </div>
            <div class="antigen-marker-board">
              <div class="antigen-marker-board-text">
                <span>Markers Applied </span>
              </div>
              <div class="antigen-marker-board-options">
                <ng-container class="Options-selected">
                  <div *ngIf="selectedOptions.length !== 0" class="selected-options">
                    <span *ngFor="let option of selectedOptions" class="selected-option">
                      {{ option.marker }}
                      <span class="remove-option" (click)="removeSelection(option)">&#10005;</span>
                    </span>
                  </div>
                </ng-container>
                <ng-container *ngIf="selectedOptions.length === 0">
                  <div class="no-markers-selected">
                    <span>No markers selected</span>
                  </div>
                </ng-container>
                <!-- <div *ngIf="selectedOptions.length !== 0" class="selected-options">
          <span *ngFor="let option of selectedOptions" class="selected-option">
            {{ option.marker }}
            <span class="remove-option" (click)="removeSelection(option)"
              >&#10005;</span
            >
          </span>
        </div> -->
              </div>
            </div>
          </div>
          <div class="asbestosis-med-records-chart">
            <!-- Progress bar -->
            <div class="progress-container">
              <div class="progress-bar" [style.width.%]="progress">
                <span class="progress-text">{{ progress }}%</span>
              </div>
            </div>
            <div class="progress-labels">
              <span *ngFor="let label of generateLabels()">{{label}}%</span>
            </div>

          </div>
          <div class="asbestosis-med-records-causation-advice">
            <div *ngIf="selectedOptions.length" class="causation-advice">
              <span *ngIf="  this.progress < 50 || this.progress >= 100" class="causation-advice-text center-text">
                {{causationAdvice}}
              </span>

              <span *ngIf=" 50 <= this.progress && this.progress < 100" class="causation-advice-text">
                {{this.adviceBtw50and100PARA1}}<br><br>
                {{this.adviceBtw50and100PARA2}}
              </span>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-12 col-xl-12">
                <div class="button_holder text-center mt-3">
                  <k-button [label]="'Save'" [color]="'brand-main'" (buttonClick)="saveImmunohistologicalProfile()">
                  </k-button>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
  [timeout]="timeout"></k-simple-alert>
<k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText" [timeout]="timeout"></k-simple-alert>